/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from "react";

export function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  maxWidthClass = "max-w-3xl",
  panelClassName = "",
  contentClassName = "max-h-[70vh] overflow-auto",
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className={`relative z-10 w-full ${maxWidthClass} ${panelClassName} rounded-xl border border-borderDefault bg-backgroundSurface shadow-xl max-h-[90vh] flex flex-col`} style={{ padding: 'var(--modal-padding)' }}>
        <div className="flex items-center justify-between mb-2 sm:mb-3 flex-shrink-0">
          <h3 className="text-base sm:text-lg font-semibold truncate pr-2">{title}</h3>
          <button className="text-textSecondary hover:text-textPrimary text-lg p-1" onClick={onClose}>✕</button>
        </div>
        <div className={`flex-1 ${contentClassName}`}>
          {children}
        </div>
        {footer && (
          <div className="mt-3 sm:mt-4 pt-2 sm:pt-3 border-t border-borderDefault flex flex-wrap justify-end gap-2 flex-shrink-0">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
